import { Avatar, Kbd } from '@pm/ui';
import { Search } from 'lucide-react';
import { Link, useLocation } from 'react-router';
import { useMe } from '@/lib/auth';
import { useBranding, useFavicon } from '@/lib/branding';
import { navItemsFor } from './nav';
import { RunningTimer } from '@/features/tasks/RunningTimer';
import { NotificationsMenu } from './NotificationsMenu';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

export function Topbar({ onOpenPalette }: { onOpenPalette: () => void }) {
  const me = useMe();
  const { pathname } = useLocation();
  const { data: branding } = useBranding();
  useFavicon(branding);
  const current =
    navItemsFor(me).find((i) => pathname.startsWith(i.to))?.label ??
    (pathname.startsWith('/settings/notifications')
      ? 'Notificações'
      : pathname.startsWith('/settings/profile')
        ? 'Meu perfil'
        : pathname.startsWith('/settings')
          ? 'Aparência'
          : pathname.startsWith('/tasks/')
            ? 'Demanda'
            : '');

  return (
    <header className="sticky top-0 z-(--z-topbar) flex h-topbar items-center gap-gap-lg border-b border-border bg-bg px-page">
      <nav aria-label="Breadcrumb" className="flex gap-1.5 text-sm text-text-2">
        <span>{branding?.display_name ?? me.organization?.name}</span>
        {current ? (
          <>
            <span aria-hidden>/</span>
            <span className="font-medium text-text-1">{current}</span>
          </>
        ) : null}
      </nav>

      <button
        type="button"
        onClick={onOpenPalette}
        className="mx-auto flex h-control-sm w-full max-w-[380px] items-center gap-2 rounded border border-border-strong bg-surface-1 px-2 pl-2.5 text-sm text-text-3 transition-[border-color,box-shadow] duration-(--dur-fast) hover:border-accent-border focus-visible:outline-none focus-visible:shadow-ring"
      >
        <Search className="size-4" aria-hidden />
        <span className="flex-1 text-left">Buscar ou comando…</span>
        <Kbd>{isMac ? '⌘K' : 'Ctrl K'}</Kbd>
      </button>

      <div className="flex items-center gap-3">
        <RunningTimer />
        <NotificationsMenu />
        <Link
          to="/settings/profile"
          title="Meu perfil"
          className="rounded-full focus-visible:outline-none focus-visible:shadow-ring"
        >
          <Avatar name={me.user.name} src={me.user.avatar_url} size="md" />
        </Link>
      </div>
    </header>
  );
}
